import api from "./api";

const getStoneRate = async (params = {}) => {
  const response = await api.get("/admin-rates/stone", {
    params: {
      ...params,
      branchCode: params.branchCode,
    },
  });
  return response.data;
};

const setStoneRate = async (stoneRateData) => {
  const response = await api.post("/admin-rates/stone", {
    ...stoneRateData,
    branchCode: stoneRateData.branchCode,
  });
  return response.data;
};

const bulkImportStoneRates = async (rates) => {
  const response = await api.post("/admin-rates/stone/bulk", {
    rates,
    branchCode: rates.branchCode,
  });
  return response.data;
};

const getDiamondMatrix = async (params = {}) => {
  const response = await api.get("/admin-rates/stone/diamond-matrix", {
    params: {
      ...params,
      branchCode: params.branchCode,
    },
  });
  return response.data;
};

const calculateStoneValue = async (calculationData) => {
  const response = await api.post("/admin-rates/stone/calculate", {
    ...calculationData,
    branchCode: calculationData.branchCode,
  });
  return response.data;
};

const syncStoneRatesFromMarket = async (syncData) => {
  const response = await api.post("/admin-rates/stone/sync", {
    ...syncData,
    branchCode: syncData.branchCode,
  });
  return response.data;
};

const stoneRateService = {
  getStoneRate,
  setStoneRate,
  bulkImportStoneRates,
  getDiamondMatrix,
  calculateStoneValue,
  syncStoneRatesFromMarket,
};

export default stoneRateService;
